<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="csSpecialApplication.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="900px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="csSpecialApplication"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <div class="vm-separate">
          <el-form-item label="申请编号">
            <el-input v-model="csSpecialApplication.billNo" disabled placeholder="系统自动生成"/>
          </el-form-item>
          <el-form-item label="售后单号" prop="afterSaleNo">
            <el-input v-model="csSpecialApplication.afterSaleNo" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.replaceBillSelect.open()">
                选择
              </el-button>
            </el-input>
            <replace-bill-select ref="replaceBillSelect" @select="selectReplaceBill"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="申请标题">
            <el-input v-model="csSpecialApplication.title" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="紧急程度">
            <el-radio-group v-model="csSpecialApplication.urgency">
              <el-radio :label="10">一般</el-radio>
              <el-radio :label="20">较急</el-radio>
              <el-radio :label="30">特急</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="客户单号">
            <el-input v-model="csSpecialApplication.customerBillNo" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="csSpecialApplication.customerName" disabled placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="出厂编号">
            <el-input v-model="csSpecialApplication.factorNo" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="电梯编号">
            <el-input v-model="csSpecialApplication.elevatorNo" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="项目名称">
            <el-input v-model="csSpecialApplication.projectName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="申请类型" prop="cause">
            <el-select v-model="csSpecialApplication.cause" placeholder="请选择申请类型">
              <el-option
                  v-for="item in constant.toSelect(constant.specialApplicationCause)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="现场描述">
          <el-input v-model="csSpecialApplication.siteDesc" type="textarea" autosize placeholder="请输入"/>
        </el-form-item>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="getDetails1">
              新建
            </el-button>
          </div>
          <el-table
              :data="csSpecialApplication.details"
              border>
            <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialNo" placeholder="请输入">
                  <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="materialName" width="200" align="center" label="物料名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialName" placeholder="请输入" autosize type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" width="100" align="center" label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="unit" width="100" align="center" label="单位">
              <template slot-scope="scope">
                <el-input v-model="scope.row.unit" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="100px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <material-c-s-select ref="selectMaterial" @select="getDetails"/>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            附件
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; float: left; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table
              v-if="csSpecialApplication.attachments"
              ref="payData"
              :data="csSpecialApplication.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.fileName"
                    class="tabInput"
                    style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  import ReplaceBillSelect from "@/views/afterSalesManagement/Replacement/ReplaceBillSelect";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";

  export default {
    name:"",
    components: {MaterialCSSelect, ReplaceBillSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        constant,
        files: [],
        imgUrls: [],
        selection: [],
        index: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        csSpecialApplication: {
          pkid: "",
          billNo: "",
          afterSaleNo: "",
          title: "",
          customerBillNo: "",
          customerName: "",
          factorNo: "",
          elevatorNo: "",
          projectName: "",
          urgency: 10,
          cause: "",
          details:[],
          attachments:[],
        },
        ruleValidate: {
          cause: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.csSpecialApplication.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.$nextTick(() => {
            this.getData();
          });
        }
      },
      fileDelete(row, index) {
        this.csSpecialApplication.attachments.splice(index, 1);
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo/10)-1);
        }
      },
      selectReplaceBill(row) {
        console.log(row);
        this.csSpecialApplication.afterSaleNo = row.billNo;
        this.csSpecialApplication.customerBillNo = row.customerBillNo;
        this.csSpecialApplication.customerId = row.customerId;
        this.csSpecialApplication.customerName = row.customerName;
        this.csSpecialApplication.factorNo = row.salesOrderNo;
        this.csSpecialApplication.elevatorNo = row.elevatorNo;
        this.csSpecialApplication.projectName = row.siteName;
        this.csSpecialApplication.siteDesc = row.note;
        this.csSpecialApplication.details = row.details;

      },
      getDetails(row, index) {
        console.log(row,index);
        this.csSpecialApplication.details[index].materialId = row.id;
        this.csSpecialApplication.details[index].materialName = row.name;
        this.csSpecialApplication.details[index].materialNo = row.no;
      },
      getDetails1() {
        this.csSpecialApplication.details.push({
          pkid: 0,
          masterId: 0,
          materialId: -1,
          materialName: "",
          materialNo: "",
          quantity: 0,
          unit: "",
        });
      },
      oneDelete(index) {
        this.csSpecialApplication.details.splice(index, 1);
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.csSpecialApplication.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.csSpecialApplication.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      getData() {
        this.$http
          .get("basic", `csSpecialApplications/${this.csSpecialApplication.pkid}`)
          .then(resp => {
            this.csSpecialApplication = resp;
            this.csSpecialApplication.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      // beforeAvatarUpload(file) {
      //   return this.$confirm(`确定移除 ${ file.name }？`);
      // },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.csSpecialApplication.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      getArrDifference(arr1) {
        let arr2= [0,1,2,3,4,5,6,7,8];
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v);
        });
      },
      handleSubmit() {
        if(this.csSpecialApplication.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "csSpecialApplications",  this.csSpecialApplication)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "csSpecialApplications", this.csSpecialApplication)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
